import { render, staticRenderFns } from "./actions-columns-manual-user.vue?vue&type=template&id=55fcf36e"
import script from "./actions-columns-manual-user.vue?vue&type=script&lang=js"
export * from "./actions-columns-manual-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports